import React from "react";
// import friendlypacksCategory from '../../Assets/Images/Eco-friendlypacksCategory.png';
// import zeroCarbides from '../../Assets/Images/ZeroCarbides.png';
// import safe from '../../Assets/Images/Safe.png';
// import scantoview from '../../Assets/Images/Scantoview.png';
// import viewLocation from '../../server-build/Images/ViewLocation.png';
import { Container } from "react-bootstrap";

function IconComponent(props) {
    return (
        <div className="row mb-5 pb-0 pb-lg-5">
            <div className="col">
                <Container>
                    <div className='row justify-content-evenly mb-2 mb-lg-0'>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2'>
                            <img className='mb-2' src="../server-build/Images/Carbide.png" />
                            <p className=' mb-0 fw-bold'>100%<br /> Carbide-free </p>
                        </div>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2'>
                            <img className='mb-2' src="../server-build/Images/Certifed.png " />
                            <p className=' mb-0 fw-bold'>Certified Safe<br />
                            from Pesticides </p>
                        </div>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2'>
                            <img className='mb-2' src="/server-build/Images/Authentic.png" />
                            <p className=' mb-0 fw-bold'>Get Authentic<br />
                            Varieties</p>
                        </div>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2'>
                            <img className='mb-2' src="../server-build/Images/Scan.png" />
                            <p className=' mb-0 fw-bold'>Scan To View<br />
                            Test Reports</p>
                        </div>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2 '>
                            <img className='mb-2' src="../server-build/Images/Eco-friendly.png" />
                            <p className=' mb-0 fw-bold'>Eco-friendly<br />
                            Pack Options</p>
                        </div>
                        <div className='col-6 col-lg-auto text-center mb-4 mb-lg-2 '>
                            <img className='mb-2' src="../server-build/Images/SafelyRipened.png" />
                            <p className=' mb-0 fw-bold'>Safely<br />
                            Ripened</p>
                        </div>
                    </div>

                  
                </Container>
            </div>
        </div>

    )
}

export default IconComponent